import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import API_BASE from '../api';

const AGE_GROUPS = ['טרום ב', 'טרום א', 'ילדים ג', 'ילדים ב', 'ילדים א', 'נערים ג', 'נערים ב', 'נערים א', 'נוער', 'בוגרים'];
const SITE = process.env.NODE_ENV === 'production' ? 'https://www.ustarclub.co.il' : 'http://localhost:3000';
const TOKEN_KEY = 'ustar_admin_token';

const STATUSES = {
  new:       { label: 'חדש',        color: '#7ab0ff' },
  working:   { label: 'בעריכה',     color: '#f0cc60' },
  done:      { label: 'הושלם',      color: '#25d366' },
};

function normPhone(p) {
  let d = String(p || '').replace(/\D/g, '');
  if (d.startsWith('972')) d = '0' + d.slice(3);
  else if (d && !d.startsWith('0')) d = '0' + d;
  return d;
}
function waLink(phone, text) {
  const d = normPhone(phone);
  const wa = d ? '972' + d.slice(1) : '';
  return `https://wa.me/${wa}${text ? `?text=${encodeURIComponent(text)}` : ''}`;
}
function fmtDate(d) {
  if (!d) return '';
  const dt = d instanceof Date ? d : new Date(String(d).slice(0, 10) + 'T00:00:00');
  if (isNaN(dt)) return String(d).slice(0, 10);
  return `${dt.getDate()}.${dt.getMonth() + 1}.${String(dt.getFullYear()).slice(2)}`;
}

const inS = { width: '100%', background: '#0a1a3e', border: '1px solid #2a3a6a', borderRadius: 10, padding: '10px 12px', color: '#fff', fontSize: '0.92rem', boxSizing: 'border-box', fontFamily: "'Heebo',sans-serif" };
const lblS = { color: '#8a9aba', fontSize: '0.78rem', fontWeight: 700, marginBottom: 5, display: 'block' };

export default function ClipOrdersApp({ onLogout }) {
  const [forms, setForms] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [flash, setFlash] = useState('');

  const [showNewForm, setShowNewForm] = useState(false);
  const [nf, setNf] = useState({ title: '', team: '', age_group: 'ילדים ב', price: '250' });

  const [fYear, setFYear] = useState('all');
  const [fTeam, setFTeam] = useState('all');
  const [fAge, setFAge] = useState('all');
  const [tab, setTab] = useState('board');
  const [showDone, setShowDone] = useState(false);
  const [manual, setManual] = useState(null);   // טופס הזמנה ידנית פתוח
  const blankManual = () => {
    const m = {}; EDIT_FIELDS.forEach(([k]) => { m[k] = ''; });
    return { ...m, product: 'קליפ כדורגל אישי', price: '250', age_group: 'ילדים ב' };
  };
  const createManual = async () => {
    try {
      const { data } = await axios.post(`${API_BASE}/clip-orders/manual`, manual, auth);
      setOrders(prev => [data, ...prev]);
      setManual(null);
      toast('✅ ההזמנה נוספה');
    } catch (err) { handleErr(err); toast(err.response?.data?.error || 'שגיאה'); }
  };

  const auth = { headers: { 'x-admin-token': localStorage.getItem(TOKEN_KEY) || '' } };

  const toast = msg => { setFlash(msg); setTimeout(() => setFlash(''), 2600); };

  const handleErr = useCallback(err => {
    if (err?.response?.status === 401) {
      try { localStorage.removeItem(TOKEN_KEY); } catch (e) { /* */ }
      if (onLogout) onLogout();
    }
  }, [onLogout]);

  const load = useCallback(() => {
    setLoading(true);
    Promise.all([
      axios.get(`${API_BASE}/clip-order-forms`, auth),
      axios.get(`${API_BASE}/clip-orders`, auth),
    ]).then(([f, o]) => { setForms(f.data); setOrders(o.data); })
      .catch(handleErr)
      .finally(() => setLoading(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [handleErr]);

  useEffect(() => { load(); }, [load]);

  const createForm = async () => {
    if (!nf.team.trim()) return toast('הזן קבוצה');
    if (!nf.price) return toast('הזן מחיר');
    try {
      const { data } = await axios.post(`${API_BASE}/clip-order-forms`, {
        title: nf.title || null, team: nf.team.trim(), age_group: nf.age_group, price: nf.price,
      }, auth);
      setForms(prev => [{ ...data, order_count: 0 }, ...prev]);
      setNf({ title: '', team: '', age_group: 'ילדים ב', price: '250' });
      setShowNewForm(false);
      toast('✅ טופס נוצר — העתק את הקישור ושלח ללקוח');
    } catch (err) { handleErr(err); toast(err.response?.data?.error || 'שגיאה'); }
  };

  const deleteForm = async f => {
    if (!window.confirm(`למחוק את טופס "${f.team} · ${f.age_group}"?`)) return;
    try { await axios.delete(`${API_BASE}/clip-order-forms/${f.id}`, auth); setForms(prev => prev.filter(x => x.id !== f.id)); }
    catch (err) { handleErr(err); }
  };

  const setStatus = async (o, status) => {
    try {
      await axios.put(`${API_BASE}/clip-orders/${o.id}/status`, { status }, auth);
      setOrders(prev => prev.map(x => x.id === o.id ? { ...x, status } : x));
    } catch (err) { handleErr(err); }
  };

  const saveOrder = async (o, patch) => {
    try {
      const { data } = await axios.put(`${API_BASE}/clip-orders/${o.id}`, patch, auth);
      setOrders(prev => prev.map(x => x.id === o.id ? data : x));
      toast('✅ ההזמנה עודכנה');
      return true;
    } catch (err) { handleErr(err); toast(err.response?.data?.error || 'שגיאה בשמירה'); return false; }
  };

  const deleteOrder = async o => {
    if (!window.confirm(`למחוק את ההזמנה של ${o.contact_name}?`)) return;
    try { await axios.delete(`${API_BASE}/clip-orders/${o.id}`, auth); setOrders(prev => prev.filter(x => x.id !== o.id)); }
    catch (err) { handleErr(err); }
  };

  const formLink = f => `${SITE}/clip-order/${f.id}`;

  // ── פילוח ──
  const years = [...new Set(orders.map(o => o.player_birth_year).filter(Boolean))].sort((a, b) => b - a);
  const teams = [...new Set(orders.map(o => o.team).filter(Boolean))].sort();
  const ages = [...new Set(orders.map(o => o.age_group).filter(Boolean))].sort((a, b) => AGE_GROUPS.indexOf(a) - AGE_GROUPS.indexOf(b));

  const filtered = orders.filter(o =>
    (fYear === 'all' || o.player_birth_year === fYear) &&
    (fTeam === 'all' || o.team === fTeam) &&
    (fAge === 'all' || o.age_group === fAge));

  // קיבוץ: מחלקת נוער (קבוצה) ← שכבת גיל, לפי הסדר טרום ב → בוגרים
  const ageRank = a => { const i = AGE_GROUPS.indexOf(a); return i < 0 ? 99 : i; };
  const byTeam = {};
  // לוח העבודה מציג רק עבודות פעילות; שהושלמו יורדות לרשימה מקופלת
  const active = filtered.filter(o => o.status !== 'done');
  const doneList = filtered.filter(o => o.status === 'done')
    .sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

  // קופה רושמת — סכום כל העבודות שהושלמו (לפי הסינון הנוכחי)
  const sum = l => l.reduce((n, o) => n + (Number(o.price) || 0), 0);
  const now = new Date();
  const thisMonth = doneList.filter(o => { const d = new Date(o.created_at); return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear(); });
  const pending = sum(active);

  active.forEach(o => {
    const t = o.team || '—', a = o.age_group || '—';
    ((byTeam[t] = byTeam[t] || {})[a] = byTeam[t][a] || []).push(o);
  });
  const teamKeys = Object.keys(byTeam).sort();

  const customerCount = new Set(orders.map(o => `${normPhone(o.contact_phone)}|${(o.player_name || '').trim()}`)).size;

  // ימי הולדת (חודש קדימה) ובר מצווה (גיל 13, שלושה חודשים קדימה)
  // שחקן אחד = שורה אחת, גם אם הזמינו כמה פעמים
  const uniqKids = Object.values(orders.reduce((m, o) => {
    const k = `${normPhone(o.contact_phone)}|${(o.player_name || '').trim()}`;
    if (!m[k]) m[k] = o;
    return m;
  }, {}));
  const birthdays = uniqKids.map(o => ({ o, days: daysUntilBirthday(o.player_birth_date, 0) }))
    .filter(x => x.days != null && x.days <= 30).sort((a, b) => a.days - b.days);
  const barMitzvahs = uniqKids.map(o => ({ o, days: daysUntilAge(o.player_birth_date, 13) }))
    .filter(x => x.days != null && x.days >= 0 && x.days <= 92).sort((a, b) => a.days - b.days);

  return (
    <div style={{ minHeight: '100vh', background: '#05080f', direction: 'rtl', fontFamily: "'Heebo',sans-serif", color: '#fff' }}>
      {/* פס עליון */}
      <div style={{ background: 'linear-gradient(180deg,#070e1e,#050b18)', borderBottom: '1px solid #1a2a4a', padding: '14px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <img src="/ustarpro.png" alt="U-STAR" style={{ height: 34, borderRadius: 7, border: '1px solid rgba(212,175,55,0.4)' }} />
          <div>
            <div style={{ color: '#d4af37', fontWeight: 900, fontSize: '1.05rem' }}>לקוחות יוסטאר — קליפ אישי</div>
            <div style={{ color: '#6a7a9a', fontSize: '0.76rem' }}>הזמנות קליפ כדורגל אישי ממשחק מצולם</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <a href="/admin" style={{ color: '#7ab0ff', textDecoration: 'none', fontSize: '0.82rem', alignSelf: 'center' }}>← מערכת הניהול</a>
          <button onClick={onLogout} style={{ background: 'transparent', color: '#ff6b6b', border: '1px solid rgba(255,107,107,0.3)', borderRadius: 8, padding: '7px 14px', cursor: 'pointer', fontSize: '0.82rem', fontWeight: 600 }}>🔓 יציאה</button>
        </div>
      </div>

      {flash && (
        <div style={{ position: 'fixed', top: 14, left: '50%', transform: 'translateX(-50%)', background: '#0d2a1a', color: '#25d366', border: '1px solid rgba(37,211,102,0.4)', borderRadius: 10, padding: '10px 20px', zIndex: 100, fontWeight: 700 }}>{flash}</div>
      )}

      <div style={{ maxWidth: 1000, margin: '0 auto', padding: '22px 18px 60px' }}>

        {/* ── טפסי הזמנה ── */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 14, flexWrap: 'wrap', gap: 10 }}>
          <h2 style={{ color: '#d4af37', margin: 0, fontSize: '1.2rem' }}>📨 טפסי הזמנה</h2>
          <button onClick={() => setShowNewForm(v => !v)} style={{ background: 'linear-gradient(135deg,#d4af37,#b8941f)', color: '#000', border: 'none', borderRadius: 10, padding: '9px 20px', cursor: 'pointer', fontWeight: 900, fontSize: '0.88rem' }}>
            {showNewForm ? '▲ סגור' : '+ צור טופס חדש'}
          </button>
        </div>

        {showNewForm && (
          <div style={{ background: 'linear-gradient(135deg,rgba(212,175,55,0.08),rgba(212,175,55,0.03))', border: '2px solid rgba(212,175,55,0.4)', borderRadius: 14, padding: '18px 20px', marginBottom: 18 }}>
            <div style={{ color: '#8a9aba', fontSize: '0.82rem', marginBottom: 14 }}>אתה קובע מראש קבוצה, שכבת גיל ומחיר. הלקוח רק ממלא את הפרטים.</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 12, marginBottom: 14 }}>
              <div><label style={lblS}>קבוצה *</label><input style={inS} value={nf.team} onChange={e => setNf(n => ({ ...n, team: e.target.value }))} placeholder="לדוגמה: בית״ר קרית גת" /></div>
              <div>
                <label style={lblS}>שכבת גיל *</label>
                <select style={inS} value={nf.age_group} onChange={e => setNf(n => ({ ...n, age_group: e.target.value }))}>
                  {AGE_GROUPS.map(a => <option key={a} value={a}>{a}</option>)}
                </select>
              </div>
              <div><label style={lblS}>מחיר (₪) *</label><input style={inS} type="number" value={nf.price} onChange={e => setNf(n => ({ ...n, price: e.target.value }))} placeholder="250" /></div>
              <div><label style={lblS}>כותרת <span style={{ fontWeight: 400 }}>(לא חובה)</span></label><input style={inS} value={nf.title} onChange={e => setNf(n => ({ ...n, title: e.target.value }))} placeholder="קליפ ביצועים אישי" /></div>
            </div>
            <button onClick={createForm} style={{ background: 'linear-gradient(135deg,#d4af37,#f0cc60)', color: '#0a1120', border: 'none', borderRadius: 10, padding: '10px 24px', cursor: 'pointer', fontWeight: 900 }}>צור קישור לטופס</button>
          </div>
        )}

        {forms.length === 0 ? (
          <div style={{ color: '#4a5a7a', fontSize: '0.88rem', padding: '0 0 10px' }}>עדיין לא יצרת טפסי הזמנה.</div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 9, marginBottom: 30 }}>
            {forms.map(f => (
              <div key={f.id} style={{ background: '#0d1b3e', border: '1px solid #1a2a4a', borderRadius: 11, padding: '12px 14px', display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: 180 }}>
                  <div style={{ color: '#fff', fontWeight: 800, fontSize: '0.92rem' }}>{f.team} · {f.age_group} · {f.price} ₪</div>
                  <a href={formLink(f)} target="_blank" rel="noopener noreferrer" style={{ color: '#7ab0ff', fontSize: '0.78rem', textDecoration: 'none' }} dir="ltr">{formLink(f)} ↗</a>
                </div>
                <div style={{ color: '#8a9aba', fontSize: '0.8rem', whiteSpace: 'nowrap' }}>📥 {f.order_count} הזמנות</div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button onClick={() => { navigator.clipboard.writeText(formLink(f)); toast('🔗 הקישור הועתק'); }} style={{ background: 'rgba(212,175,55,0.1)', color: '#d4af37', border: '1px solid rgba(212,175,55,0.4)', borderRadius: 8, padding: '6px 12px', cursor: 'pointer', fontSize: '0.78rem', fontWeight: 700 }}>🔗 העתק</button>
                  <a href={waLink('', `הזמנת קליפ כדורגל אישי — ${f.team} ${f.age_group}\n${formLink(f)}`)} target="_blank" rel="noopener noreferrer" style={{ background: 'rgba(37,211,102,0.14)', color: '#25d366', border: '1px solid rgba(37,211,102,0.4)', borderRadius: 8, padding: '6px 12px', textDecoration: 'none', fontSize: '0.78rem', fontWeight: 700 }}>📱 שתף</a>
                  <button onClick={() => deleteForm(f)} style={{ background: 'rgba(255,80,80,0.08)', color: '#ff8888', border: '1px solid rgba(255,80,80,0.28)', borderRadius: 8, padding: '6px 10px', cursor: 'pointer', fontSize: '0.78rem' }}>🗑</button>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* ── טאבים ── */}
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 18, borderBottom: '1px solid #1a2a4a', paddingBottom: 12 }}>
          {[['board', `🎬 לוח עבודה (${active.length})`], ['customers', `👥 לקוחות (${customerCount})`], ['bday', `🎂 ימי הולדת (${birthdays.length})`], ['bar', `✡️ בר מצווה (${barMitzvahs.length})`]].map(([k, l]) => (
            <button key={k} onClick={() => setTab(k)} style={{ background: tab === k ? 'linear-gradient(135deg,#d4af37,#f0cc60)' : '#0d1b3e', color: tab === k ? '#0a1120' : '#c0cce6', border: `1px solid ${tab === k ? '#d4af37' : '#2a3a6a'}`, borderRadius: 10, padding: '9px 18px', cursor: 'pointer', fontWeight: 800, fontSize: '0.9rem' }}>{l}</button>
          ))}
        </div>

        {tab === 'board' && (<>
        <div style={{ marginBottom: 14 }}>
          <button onClick={() => setManual(m => m ? null : blankManual())} style={{ background: manual ? 'transparent' : 'rgba(122,176,255,0.12)', color: '#7ab0ff', border: '1px solid rgba(122,176,255,0.4)', borderRadius: 10, padding: '9px 18px', cursor: 'pointer', fontWeight: 800, fontSize: '0.88rem' }}>
            {manual ? '▲ סגור' : '✍️ הזמנה ידנית — אני ממלא בשביל ההורה'}
          </button>
          {manual && (
            <div style={{ marginTop: 12, background: 'rgba(122,176,255,0.06)', border: '2px solid rgba(122,176,255,0.35)', borderRadius: 14, padding: '16px 18px' }}>
              <div style={{ color: '#8a9aba', fontSize: '0.82rem', marginBottom: 12 }}>להורים שלא יכולים למלא בעצמם. חובה: שם הורה, טלפון ושם השחקן.</div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 10, marginBottom: 12 }}>
                {EDIT_FIELDS.map(([k, l, type]) => (
                  <div key={k}>
                    <label style={lblS}>{l}{['contact_name', 'contact_phone', 'player_name'].includes(k) ? ' *' : ''}</label>
                    {type === 'age' ? (
                      <select style={inS} value={manual[k]} onChange={e => setManual(m => ({ ...m, [k]: e.target.value }))}>
                        {AGE_GROUPS.map(a => <option key={a} value={a}>{a}</option>)}
                      </select>
                    ) : (
                      <input style={inS} type={type === 'date' ? 'date' : type === 'number' ? 'number' : 'text'} value={manual[k]}
                        placeholder={k === 'player_positions' ? 'לדוגמה: חלוץ, כנף' : ''}
                        onChange={e => setManual(m => ({ ...m, [k]: e.target.value }))} />
                    )}
                  </div>
                ))}
              </div>
              <button onClick={createManual} style={{ background: 'linear-gradient(135deg,#d4af37,#f0cc60)', color: '#0a1120', border: 'none', borderRadius: 9, padding: '9px 22px', cursor: 'pointer', fontWeight: 900 }}>➕ הוסף הזמנה</button>
            </div>
          )}
        </div>
        {/* ── קופה רושמת ── */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 10, marginBottom: 16 }}>
          {[
            ['💰 בקופה — הושלמו', `${sum(doneList).toLocaleString('he-IL')} ₪`, `${doneList.length} עבודות`, '#25d366'],
            ['📅 החודש', `${sum(thisMonth).toLocaleString('he-IL')} ₪`, `${thisMonth.length} עבודות`, '#f0cc60'],
            ['⏳ בעבודה — עוד לא נכנס', `${pending.toLocaleString('he-IL')} ₪`, `${active.length} עבודות`, '#7ab0ff'],
          ].map(([l, v, sub, c]) => (
            <div key={l} style={{ background: '#0d1b3e', border: `1px solid ${c}55`, borderRadius: 12, padding: '12px 14px' }}>
              <div style={{ color: '#8a9aba', fontSize: '0.76rem', fontWeight: 700 }}>{l}</div>
              <div style={{ color: c, fontWeight: 900, fontSize: '1.45rem', margin: '4px 0 2px' }}>{v}</div>
              <div style={{ color: '#5a6a90', fontSize: '0.74rem' }}>{sub}</div>
            </div>
          ))}
        </div>

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 16 }}>
          <Filter label="מחלקת נוער" value={fTeam} set={setFTeam} opts={teams} />
          <Filter label="שכבת גיל" value={fAge} set={setFAge} opts={ages} />
          <Filter label="שנתון" value={fYear} set={setFYear} opts={years} />
        </div>

        {loading ? (
          <div style={{ color: '#8a9aba', padding: '20px 0' }}>טוען…</div>
        ) : active.length === 0 ? (
          <div style={{ color: '#4a5a7a', textAlign: 'center', padding: '40px 20px' }}>אין עבודות פעילות כרגע 🎉</div>
        ) : (
          teamKeys.map(team => {
            const ageMap = byTeam[team];
            const total = Object.values(ageMap).reduce((n, l) => n + l.length, 0);
            return (
              <div key={team} style={{ marginBottom: 28, border: '1px solid rgba(212,175,55,0.3)', borderRadius: 14, overflow: 'hidden' }}>
                <div style={{ background: 'linear-gradient(135deg,rgba(212,175,55,0.18),rgba(212,175,55,0.05))', padding: '12px 16px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ color: '#f0cc60', fontWeight: 900, fontSize: '1.1rem' }}>🏟 {team}</div>
                  <div style={{ color: '#c0cce6', fontSize: '0.82rem', fontWeight: 700 }}>{total} לקוחות</div>
                </div>
                <div style={{ padding: '12px 14px' }}>
                  {Object.keys(ageMap).sort((a, b) => ageRank(a) - ageRank(b)).map(age => (
                    <div key={age} style={{ marginBottom: 14 }}>
                      <div style={{ color: '#7ab0ff', fontWeight: 800, fontSize: '0.92rem', margin: '4px 0 8px', borderRight: '3px solid #7ab0ff', paddingRight: 8 }}>
                        {age} <span style={{ color: '#8a9aba', fontWeight: 600 }}>({ageMap[age].length})</span>
                      </div>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                        {ageMap[age].map(o => <OrderCard key={o.id} o={o} setStatus={setStatus} deleteOrder={deleteOrder} saveOrder={saveOrder} />)}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            );
          })
        )}

        {/* ── הושלמו — מקופל ── */}
        {doneList.length > 0 && (
          <div style={{ marginTop: 24 }}>
            <button onClick={() => setShowDone(v => !v)} style={{ background: 'transparent', color: '#25d366', border: '1px solid rgba(37,211,102,0.35)', borderRadius: 9, padding: '7px 14px', cursor: 'pointer', fontWeight: 800, fontSize: '0.84rem' }}>
              {showDone ? '▲' : '▼'} ✅ הושלמו ({doneList.length})
            </button>
            {showDone && (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 5, marginTop: 10 }}>
                {doneList.map(o => (
                  <div key={o.id} style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap', background: 'rgba(37,211,102,0.05)', border: '1px solid rgba(37,211,102,0.2)', borderRadius: 8, padding: '6px 12px', fontSize: '0.8rem' }}>
                    <span style={{ color: '#fff', fontWeight: 800 }}>{o.player_name || '—'}</span>
                    <span style={{ color: '#8a9aba' }}>{[o.team, o.age_group].filter(Boolean).join(' · ')}</span>
                    <span style={{ color: '#5a6a90' }}>{o.contact_name}</span>
                    <span style={{ color: '#25d366', fontWeight: 900, marginRight: 'auto' }}>{o.price != null ? `${o.price} ₪` : ''}</span>
                    <span style={{ color: '#5a6a90' }}>{fmtDate(o.created_at)}</span>
                    <button onClick={() => setStatus(o, 'working')} title="החזר ללוח העבודה" style={{ background: 'transparent', color: '#8a9aba', border: '1px solid #2a3a6a', borderRadius: 6, padding: '2px 8px', cursor: 'pointer', fontSize: '0.72rem' }}>↩ החזר</button>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        </>)}

        {tab === 'customers' && (
          <CustomersTab orders={orders} auth={auth} toast={toast} handleErr={handleErr} />
        )}

        {tab === 'bday' && (
          <EventList items={birthdays} empty="אין ימי הולדת בחודש הקרוב."
            note="🎁 חודש לפני יום ההולדת — מתנה: קלף הכוכבים של יוסטאר"
            badge={d => d === 0 ? '🎉 היום!' : `בעוד ${d} ימים`}
            when={o => `יום הולדת ${ageOn(o.player_birth_date)} · ${fmtDate(nextAnniversary(o.player_birth_date, null))}`}
            msg={o => `שלום ${o.contact_name}! 🎂\nיום ההולדת של ${o.player_name || 'השחקן/ית'} מתקרב — ולכבוד היום יוסטאר מעניקה ל${o.player_name ? o.player_name.split(' ')[0] : 'שחקן/ית'} מתנה: קלף הכוכבים האישי! ⭐\n\nמזל טוב מכל צוות יוסטאר ⚽`} />
        )}

        {tab === 'bar' && (
          <EventList items={barMitzvahs} empty="אין חגיגות בר מצווה בשלושת החודשים הקרובים."
            note="✡️ שלושה חודשים לפני גיל 13 — הצעה: קליפ בר מצווה של יוסטאר + קלף הכוכבים מתנה"
            badge={d => d === 0 ? '🎉 היום!' : `בעוד ${d} ימים`}
            when={o => `גיל 13 · ${fmtDate(nextAnniversary(o.player_birth_date, 13))}`}
            msg={o => `שלום ${o.contact_name}! ✡️\nבעוד כמה חודשים ${o.player_name ? o.player_name.split(' ')[0] : 'השחקן/ית'} חוגג/ת בר/בת מצווה — מזל טוב!\n\nיוסטאר מציעה קליפ בר מצווה אישי — רגעי הכדורגל הגדולים בסרט אחד לחגיגה 🎬\nובנוסף, מתנה מאיתנו: קלף הכוכבים האישי ⭐\n\nנשמח לספר עוד — יוסטאר ⚽`} />
        )}
      </div>
    </div>
  );
}

// תאריך הלידה כ-Date מקומי
function parseDob(d) {
  const m = String(d || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  return { y: +m[1], m: +m[2] - 1, d: +m[3] };
}
function today0() { const t = new Date(); return new Date(t.getFullYear(), t.getMonth(), t.getDate()); }
// המועד הבא של יום ההולדת (age=null) או של גיל מסוים (age=13)
function nextAnniversary(dob, age) {
  const b = parseDob(dob); if (!b) return null;
  if (age != null) return new Date(b.y + age, b.m, b.d);
  const t = today0();
  let n = new Date(t.getFullYear(), b.m, b.d);
  if (n < t) n = new Date(t.getFullYear() + 1, b.m, b.d);
  return n;
}
function daysUntilBirthday(dob) {
  const n = nextAnniversary(dob, null); if (!n) return null;
  return Math.round((n - today0()) / 86400000);
}
function daysUntilAge(dob, age) {
  const n = nextAnniversary(dob, age); if (!n) return null;
  return Math.round((n - today0()) / 86400000);
}
function ageOn(dob) {
  const b = parseDob(dob); const n = nextAnniversary(dob, null);
  return b && n ? n.getFullYear() - b.y : '';
}

function EventList({ items, empty, note, badge, when, msg }) {
  return (
    <div>
      <div style={{ background: 'rgba(212,175,55,0.07)', border: '1px solid rgba(212,175,55,0.3)', borderRadius: 10, padding: '10px 14px', color: '#f0cc60', fontSize: '0.88rem', fontWeight: 700, marginBottom: 14 }}>{note}</div>
      {items.length === 0 ? (
        <div style={{ color: '#4a5a7a', textAlign: 'center', padding: '40px 20px' }}>{empty}</div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {items.map(({ o, days }) => (
            <div key={o.id} style={{ background: '#0d1b3e', border: '1px solid #2a3a6a', borderRadius: 12, padding: '14px 16px', display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
              <div style={{ background: days <= 7 ? '#f0cc60' : 'rgba(122,176,255,0.15)', color: days <= 7 ? '#0a1120' : '#7ab0ff', borderRadius: 8, padding: '6px 10px', fontWeight: 900, fontSize: '0.82rem', whiteSpace: 'nowrap' }}>{badge(days)}</div>
              <div style={{ flex: 1, minWidth: 180 }}>
                <div style={{ color: '#fff', fontWeight: 900 }}>{o.player_name || '—'}</div>
                <div style={{ color: '#c0cce6', fontSize: '0.82rem' }}>{[o.team, o.age_group].filter(Boolean).join(' · ')}</div>
                <div style={{ color: '#8a9aba', fontSize: '0.78rem', marginTop: 2 }}>{when(o)} · הורה: {o.contact_name} · {normPhone(o.contact_phone)}</div>
              </div>
              <a href={waLink(o.contact_phone, msg(o))} target="_blank" rel="noopener noreferrer" style={{ background: '#25d366', color: '#fff', borderRadius: 8, padding: '8px 14px', textDecoration: 'none', fontSize: '0.82rem', fontWeight: 800 }}>📱 שלח להורה</a>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

// ── לקוחות: הורה + שחקן, ממוינים לפי קבוצה ← שכבת גיל ← שנתון ──
function CustomersTab({ orders, auth, toast, handleErr }) {
  const [open, setOpen] = useState(null);       // מפתח הלקוח שהטופס החוזר שלו פתוח
  const [rf, setRf] = useState({});             // product / price / team / age_group
  const [made, setMade] = useState({});         // מפתח → { link, product }

  // לקוח = הורה (טלפון) + שחקן. ההזמנה האחרונה היא מקור הפרטים.
  const map = {};
  orders.forEach(o => {
    const key = `${normPhone(o.contact_phone)}|${(o.player_name || '').trim()}`;
    (map[key] = map[key] || { key, list: [] }).list.push(o);
  });
  const customers = Object.values(map).map(c => {
    c.list.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
    return { ...c, last: c.list[0] };
  });

  const rank = a => { const i = AGE_GROUPS.indexOf(a); return i < 0 ? 99 : i; };
  customers.sort((a, b) =>
    (a.last.team || '').localeCompare(b.last.team || '', 'he') ||
    rank(a.last.age_group) - rank(b.last.age_group) ||
    String(a.last.player_birth_year || '').localeCompare(String(b.last.player_birth_year || '')) ||
    (a.last.contact_name || '').localeCompare(b.last.contact_name || '', 'he'));

  const startRepeat = c => {
    setOpen(c.key);
    setRf({ product: 'קליפ כדורגל אישי', price: String(c.last.price ?? 250), team: c.last.team || '', age_group: c.last.age_group || 'ילדים ב' });
  };

  const createRepeat = async c => {
    try {
      const { data } = await axios.post(`${API_BASE}/clip-order-forms/repeat`, { orderId: c.last.id, ...rf }, auth);
      setMade(m => ({ ...m, [c.key]: { link: `${SITE}/clip-order/${data.token}`, product: data.product } }));
      setOpen(null);
      toast('✅ טופס חוזר נוצר');
    } catch (err) { handleErr(err); toast(err.response?.data?.error || 'שגיאה'); }
  };

  if (customers.length === 0) return <div style={{ color: '#4a5a7a', textAlign: 'center', padding: '40px 20px' }}>עדיין אין לקוחות.</div>;

  let lastHead = '';
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {customers.map(c => {
        const o = c.last;
        const head = [o.team || '—', o.age_group || '—', o.player_birth_year ? `שנתון ${o.player_birth_year}` : '—'].join(' · ');
        const showHead = head !== lastHead; lastHead = head;
        const m = made[c.key];
        const first = (o.player_name || '').split(' ')[0];
        return (
          <React.Fragment key={c.key}>
            {showHead && (
              <div style={{ color: '#f0cc60', fontWeight: 900, fontSize: '0.95rem', padding: '8px 12px', background: 'rgba(212,175,55,0.07)', border: '1px solid rgba(212,175,55,0.25)', borderRadius: 10, marginTop: 10 }}>{head}</div>
            )}
            <div style={{ background: '#0d1b3e', border: '1px solid #1a2a4a', borderRadius: 11, padding: '12px 14px' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: 200 }}>
                  <div style={{ color: '#fff', fontWeight: 900, fontSize: '0.98rem' }}>
                    {o.contact_name}
                    {c.list.length > 1 && <span style={{ background: 'rgba(37,211,102,0.15)', color: '#25d366', borderRadius: 6, padding: '1px 8px', fontSize: '0.72rem', fontWeight: 900, marginRight: 8 }}>🔁 לקוח חוזר ×{c.list.length}</span>}
                  </div>
                  <div style={{ color: '#c0cce6', fontSize: '0.84rem', marginTop: 2 }}>
                    <span style={{ fontFamily: 'monospace', direction: 'ltr', display: 'inline-block' }}>{normPhone(o.contact_phone)}</span>
                    {o.contact_email && <span style={{ color: '#8a9aba' }}> · {o.contact_email}</span>}
                  </div>
                  <div style={{ color: '#8a9aba', fontSize: '0.8rem', marginTop: 2 }}>⚽ {o.player_name || '—'}{o.player_birth_date && ` · 🎂 ${fmtDate(o.player_birth_date)}`}</div>
                  <div style={{ color: '#5a6a90', fontSize: '0.74rem', marginTop: 2 }}>
                    {c.list.map(x => `${x.product || 'קליפ'} (${x.price ?? '—'} ₪, ${fmtDate(x.created_at)})`).join(' · ')}
                  </div>
                </div>
                <button onClick={() => open === c.key ? setOpen(null) : startRepeat(c)}
                  style={{ background: 'linear-gradient(135deg,#d4af37,#b8941f)', color: '#000', border: 'none', borderRadius: 9, padding: '8px 14px', cursor: 'pointer', fontWeight: 900, fontSize: '0.82rem' }}>
                  {open === c.key ? '▲ סגור' : '➕ טופס חוזר'}
                </button>
              </div>

              {open === c.key && (
                <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #16233f' }}>
                  <div style={{ color: '#8a9aba', fontSize: '0.8rem', marginBottom: 10 }}>פרטי ההורה והשחקן ייכנסו לטופס אוטומטית. ההורה ימלא רק עמדה ומספר חולצה.</div>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 10, marginBottom: 12 }}>
                    <div><label style={lblS}>סוג המוצר *</label><input style={inS} value={rf.product} onChange={e => setRf(r => ({ ...r, product: e.target.value }))} placeholder="לדוגמה: קליפ בר מצווה" /></div>
                    <div><label style={lblS}>מחיר (₪) *</label><input style={inS} type="number" value={rf.price} onChange={e => setRf(r => ({ ...r, price: e.target.value }))} /></div>
                    <div><label style={lblS}>קבוצה</label><input style={inS} value={rf.team} onChange={e => setRf(r => ({ ...r, team: e.target.value }))} /></div>
                    <div>
                      <label style={lblS}>שכבת גיל</label>
                      <select style={inS} value={rf.age_group} onChange={e => setRf(r => ({ ...r, age_group: e.target.value }))}>
                        {AGE_GROUPS.map(a => <option key={a} value={a}>{a}</option>)}
                      </select>
                    </div>
                  </div>
                  <button onClick={() => createRepeat(c)} style={{ background: 'linear-gradient(135deg,#d4af37,#f0cc60)', color: '#0a1120', border: 'none', borderRadius: 9, padding: '9px 20px', cursor: 'pointer', fontWeight: 900 }}>צור טופס ללקוח</button>
                </div>
              )}

              {m && (
                <div style={{ marginTop: 12, padding: '10px 12px', background: 'rgba(37,211,102,0.07)', border: '1px solid rgba(37,211,102,0.3)', borderRadius: 9, display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                  <a href={m.link} target="_blank" rel="noopener noreferrer" dir="ltr" style={{ color: '#7ab0ff', fontSize: '0.78rem', flex: 1, minWidth: 180, wordBreak: 'break-all' }}>{m.link}</a>
                  <button onClick={() => { navigator.clipboard.writeText(m.link); toast('🔗 הקישור הועתק'); }} style={{ background: 'rgba(212,175,55,0.1)', color: '#d4af37', border: '1px solid rgba(212,175,55,0.4)', borderRadius: 8, padding: '6px 12px', cursor: 'pointer', fontSize: '0.78rem', fontWeight: 700 }}>🔗 העתק</button>
                  <a href={waLink(o.contact_phone, `שלום ${o.contact_name}! ⚽\nהכנו לכם טופס הזמנה ל${m.product || 'קליפ'} של ${first || 'השחקן/ית'} — הפרטים כבר בפנים, רק עמדה ומספר חולצה ושלחו:\n${m.link}\n\nיוסטאר`)} target="_blank" rel="noopener noreferrer" style={{ background: '#25d366', color: '#fff', borderRadius: 8, padding: '6px 12px', textDecoration: 'none', fontSize: '0.78rem', fontWeight: 800 }}>📱 שלח להורה</a>
                </div>
              )}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

function Filter({ label, value, set, opts }) {
  return (
    <div>
      <div style={{ color: '#8a9aba', fontSize: '0.74rem', marginBottom: 4 }}>{label}</div>
      <select value={value} onChange={e => set(e.target.value)} style={{ ...inS, minWidth: 130, padding: '8px 10px' }}>
        <option value="all">הכל</option>
        {opts.map(o => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );
}

const EDIT_FIELDS = [
  ['player_name', 'שם השחקן/ית'], ['player_birth_date', 'תאריך לידה', 'date'], ['player_shirt', 'מספר חולצה'],
  ['player_positions', 'עמדות'], ['contact_name', 'שם ההורה'], ['contact_phone', 'טלפון'],
  ['contact_email', 'אימייל'], ['team', 'קבוצה'], ['age_group', 'שכבת גיל', 'age'],
  ['product', 'סוג המוצר'], ['price', 'מחיר (₪)', 'number'],
];

function OrderCard({ o, setStatus, deleteOrder, saveOrder }) {
  const st = STATUSES[o.status] || STATUSES.new;
  const [editing, setEditing] = useState(false);
  const [ef, setEf] = useState({});
  const startEdit = () => {
    const init = {};
    EDIT_FIELDS.forEach(([k]) => { init[k] = o[k] == null ? '' : String(k === 'player_birth_date' ? String(o[k]).slice(0, 10) : o[k]); });
    setEf(init); setEditing(true);
  };
  const save = async () => { if (await saveOrder(o, ef)) setEditing(false); };
  const waMsg = `שלום ${o.contact_name}! 🎬\nקיבלנו את הזמנת הקליפ האישי של ${o.player_name || 'השחקן/ית'} (${o.team || ''} ${o.age_group || ''}).\nנתאם את התשלום וההכנה.\n\nיוסטאר ⚽`;
  return (
    <div style={{
      background: o.status === 'done' ? 'linear-gradient(135deg,#0b2e1c,#0a2418)' : o.status === 'working' ? 'linear-gradient(135deg,#2a2410,#1f1b0c)' : '#0d1b3e',
      border: `${o.status === 'done' ? 2 : 1}px solid ${o.status === 'done' ? '#25d366' : st.color + '44'}`,
      borderRadius: 12, padding: '14px 16px', transition: 'background 0.3s',
    }}>
      {o.status === 'done' && <div style={{ color: '#25d366', fontWeight: 900, fontSize: '0.78rem', marginBottom: 6 }}>✅ הקליפ הושלם</div>}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 200 }}>
          <div style={{ color: '#fff', fontWeight: 900, fontSize: '1.02rem' }}>
            {o.player_name || '—'}
            {o.player_shirt && <span style={{ background: 'rgba(122,176,255,0.16)', color: '#7ab0ff', borderRadius: 5, padding: '1px 7px', fontSize: '0.74rem', fontWeight: 900, marginRight: 8 }}>👕 {o.player_shirt}</span>}
          </div>
          <div style={{ color: '#c0cce6', fontSize: '0.84rem', marginTop: 3 }}>
            {[o.team, o.age_group, o.player_birth_year && `שנתון ${o.player_birth_year}`].filter(Boolean).join(' · ')}
          </div>
          {o.player_positions && <div style={{ color: '#8a9aba', fontSize: '0.8rem', marginTop: 2 }}>⚽ {o.player_positions}</div>}
          {o.player_birth_date && <div style={{ color: '#6a7ba0', fontSize: '0.78rem', marginTop: 2 }}>🎂 {fmtDate(o.player_birth_date)}</div>}
        </div>
        <div style={{ textAlign: 'left' }}>
          {o.price != null && <div style={{ color: '#25d366', fontWeight: 900, fontSize: '1.05rem' }}>{o.price} ₪</div>}
          <div style={{ color: '#5a6a90', fontSize: '0.72rem', marginTop: 2 }}>{fmtDate(o.created_at)}</div>
        </div>
      </div>

      {/* פרטי קשר */}
      <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginTop: 10, padding: '10px 0 0', borderTop: '1px solid #16233f' }}>
        <div>
          <div style={{ color: '#8a9aba', fontSize: '0.73rem' }}>מזמין</div>
          <div style={{ color: '#fff', fontSize: '0.86rem', fontWeight: 700 }}>{o.contact_name}</div>
        </div>
        <div>
          <div style={{ color: '#8a9aba', fontSize: '0.73rem' }}>טלפון</div>
          <div style={{ color: '#c0cce6', fontSize: '0.86rem', fontFamily: 'monospace', direction: 'ltr', textAlign: 'right' }}>{normPhone(o.contact_phone)}</div>
        </div>
        {o.contact_email && (
          <div>
            <div style={{ color: '#8a9aba', fontSize: '0.73rem' }}>אימייל</div>
            <div style={{ color: '#c0cce6', fontSize: '0.82rem', direction: 'ltr', textAlign: 'right' }}>{o.contact_email}</div>
          </div>
        )}
      </div>

      {/* פעולות */}
      <div style={{ display: 'flex', gap: 7, flexWrap: 'wrap', marginTop: 12, alignItems: 'center' }}>
        <a href={waLink(o.contact_phone, waMsg)} target="_blank" rel="noopener noreferrer" style={{ background: '#25d366', color: '#fff', borderRadius: 8, padding: '6px 14px', textDecoration: 'none', fontSize: '0.8rem', fontWeight: 800 }}>📱 וואטסאפ למזמין</a>
        <div style={{ display: 'flex', gap: 5, marginRight: 'auto' }}>
          {Object.entries(STATUSES).map(([k, v]) => (
            <button key={k} onClick={() => setStatus(o, k)}
              style={{ background: o.status === k ? v.color : 'transparent', color: o.status === k ? '#06101f' : v.color, border: `1px solid ${v.color}66`, borderRadius: 7, padding: '5px 12px', cursor: 'pointer', fontSize: '0.76rem', fontWeight: 800 }}>{v.label}</button>
          ))}
        </div>
        <button onClick={() => editing ? setEditing(false) : startEdit()} style={{ background: 'rgba(122,176,255,0.1)', color: '#7ab0ff', border: '1px solid rgba(122,176,255,0.35)', borderRadius: 7, padding: '5px 10px', cursor: 'pointer', fontSize: '0.76rem', fontWeight: 700 }}>✏️ עריכה</button>
        <button onClick={() => deleteOrder(o)} style={{ background: 'rgba(255,80,80,0.08)', color: '#ff8888', border: '1px solid rgba(255,80,80,0.28)', borderRadius: 7, padding: '5px 10px', cursor: 'pointer', fontSize: '0.76rem' }}>🗑</button>
      </div>

      {editing && (
        <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #16233f' }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(150px,1fr))', gap: 10, marginBottom: 12 }}>
            {EDIT_FIELDS.map(([k, l, type]) => (
              <div key={k}>
                <label style={lblS}>{l}</label>
                {type === 'age' ? (
                  <select style={inS} value={ef[k]} onChange={e => setEf(f => ({ ...f, [k]: e.target.value }))}>
                    {!AGE_GROUPS.includes(ef[k]) && <option value={ef[k]}>{ef[k] || '—'}</option>}
                    {AGE_GROUPS.map(a => <option key={a} value={a}>{a}</option>)}
                  </select>
                ) : (
                  <input style={inS} type={type === 'date' ? 'date' : type === 'number' ? 'number' : 'text'} value={ef[k]} onChange={e => setEf(f => ({ ...f, [k]: e.target.value }))} />
                )}
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={save} style={{ background: 'linear-gradient(135deg,#d4af37,#f0cc60)', color: '#0a1120', border: 'none', borderRadius: 9, padding: '8px 20px', cursor: 'pointer', fontWeight: 900 }}>💾 שמור</button>
            <button onClick={() => setEditing(false)} style={{ background: 'transparent', color: '#8a9aba', border: '1px solid #2a3a6a', borderRadius: 9, padding: '8px 16px', cursor: 'pointer' }}>ביטול</button>
          </div>
        </div>
      )}
    </div>
  );
}
